import { Localized } from "@fluent/react";
import { Card, CardContent, CardHeader, Divider, LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { getAlarmGroups } from "../../store/thunk/alarmGroup";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { AlarmGroupState, RejectionReason } from "../../store/slices/alarmGroup";
import { fullName } from "../../types/lib";
import { OrganizationMemberRole } from "../../types/model";
import { selectRole } from "../../store/slices/session";

interface AlarmGroupListProps {
	filterOnUserID: string;
	alarmGroup: AlarmGroupState;
}

function AlarmGroupList({ filterOnUserID, alarmGroup }: AlarmGroupListProps) {
	if (alarmGroup.kind === 'initializing') {
		if (alarmGroup.rejectionReason !== undefined) {
			switch (alarmGroup.rejectionReason) {
				case RejectionReason.Network:
					return <Localized id="loading-failed-network" />;
				case RejectionReason.Bug:
					return <Localized id="loading-failed-bug" />;
			}
		}

		return <LinearProgress sx={{ height: "8px" }} />;
	}
	const alarmGroups = alarmGroup.alarmGroups
		.filter(alarmGroup => alarmGroup.users.find(user => user.user_id === filterOnUserID))
		.map(alarmGroup => { console.log(alarmGroup); return alarmGroup });

	return <>
		{alarmGroups.length > 0
			? <Localized id="profile-screen-alarm-group-prefix" vars={{ amount: alarmGroups.length }} />
			: <Localized id="profile-screen-alarm-group-prefix-none" />
		}
		<ul>
			{alarmGroups.map(alarmGroup =>
				<li key={alarmGroup.alarm_group_id}>{alarmGroup.template.title}</li>)}
		</ul>
	</>;
}

export default function PersonalProfileCard() {
	const dispatch = useAppDispatch();
	const session = useAppSelector(state => state.session);
	if (!session.authenticated) {
		throw new Error("must be authenticated");
	}

	const alarmGroup = useAppSelector(state => state.alarmGroup);
	useEffect(() => {
		// If we don't have data yet and no attempt was made to request it,
		// dispatch a request to get the data of the alarm groups.
		if (alarmGroup.kind === "initializing"
			&& !alarmGroup.pending && alarmGroup.rejectionReason === undefined) {
			dispatch(getAlarmGroups());
		}
	}, [dispatch, alarmGroup]);

	const user = session.user;
	const role = selectRole(session);

	return <Card>
		<Localized
			id="profile-screen-header"
			attrs={{title: true, subheader: true}}
			vars={{
				name: fullName(user),
				email: user.email,
				role: role >= OrganizationMemberRole.Admin ? 'admin' : 'regular',
			}}
		>
			<CardHeader />
		</Localized>
		<Divider />
		<CardContent>
			<AlarmGroupList filterOnUserID={session.user.user_id} alarmGroup={alarmGroup} />
		</CardContent>
	</Card>;
}
